import ErrorIcon from "@/components/shared/Toaster/ErrorIcon"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import Typography from "../Typography"

const showErrorToast = (heading: string, description?: string) => {
  toast(
    <div className="flex  flex-row  items-center gap-4">
      <ErrorIcon />
      <div className="flex  flex-col gap-2">
        <div>
          <Typography type="h4" className="text-error-400">
            {heading}
          </Typography>
        </div>

        <div>
          {description && (
            <Typography type="m" className="text-error-400">
              {description}
            </Typography>
          )}
        </div>
      </div>
    </div>,
  )
}

export default showErrorToast
